module.exports = __webpack_public_path__ + "img/chp-move.fbb4e397.png";